"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @flow
const react_1 = __importStar(require("react"));
const Canvas = (0, react_1.forwardRef)((_a, ref) => {
    var { color } = _a, other = __rest(_a, ["color"]);
    const canvasRef = (0, react_1.useRef)(null);
    const [isPainting, setIsPainting] = (0, react_1.useState)(false);
    const [mousePosition, setMousePosition] = (0, react_1.useState)(undefined);
    const getCoordinates = (event) => {
        if (!canvasRef.current) {
            return undefined;
        }
        const canvas = canvasRef.current;
        return { x: event.pageX - canvas.offsetLeft, y: event.pageY - canvas.offsetTop };
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        clear() {
            const canvas = canvasRef.current;
            let width = { canvas };
            width += 0;
            canvas.width = width;
        },
    }));
    const startPaint = (0, react_1.useCallback)((event) => {
        const coordinates = getCoordinates(event);
        if (coordinates) {
            setMousePosition(coordinates);
            setIsPainting(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return undefined;
        }
        const canvas = canvasRef.current;
        canvas.addEventListener('mousedown', startPaint);
        return () => {
            canvas.removeEventListener('mousedown', startPaint);
        };
    }, [startPaint]);
    const drawLine = (0, react_1.useCallback)((originalMousePosition, newMousePosition) => {
        if (!canvasRef.current) {
            return;
        }
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        if (context) {
            context.strokeStyle = color;
            context.lineJoin = 'round';
            context.lineWidth = 5;
            context.beginPath();
            context.moveTo(originalMousePosition.x, originalMousePosition.y);
            context.lineTo(newMousePosition.x, newMousePosition.y);
            context.closePath();
            context.stroke();
        }
    }, [color]);
    const paint = (0, react_1.useCallback)((event) => {
        if (isPainting) {
            const newMousePosition = getCoordinates(event);
            if (mousePosition && newMousePosition) {
                drawLine(mousePosition, newMousePosition);
                setMousePosition(newMousePosition);
            }
        }
    }, [drawLine, isPainting, mousePosition]);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return undefined;
        }
        const canvas = canvasRef.current;
        canvas.addEventListener('mousemove', paint);
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
        }
        return () => {
            canvas.removeEventListener('mousemove', paint);
        };
    }, [paint]);
    const exitPaint = (0, react_1.useCallback)(() => {
        setIsPainting(false);
        setMousePosition(undefined);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return undefined;
        }
        document.addEventListener('mouseup', exitPaint);
        document.addEventListener('mouseleave', exitPaint);
        return () => {
            document.removeEventListener('mouseup', exitPaint);
            document.removeEventListener('mouseleave', exitPaint);
        };
    }, [exitPaint]);
    return <canvas ref={canvasRef} {...other}/>;
});
exports.default = Canvas;
